import { l } from '@manychat/manyui'
import { MakeTranslateReturnValue } from '@manychat/manyui/src/utils/localization/format'

import { ChatMessageType } from 'apps/chat/types/chatMessageTypeList'
import { ChannelType } from 'common/core/constants/ChannelType'

export const MAX_SCHEDULED_MESSAGES_COUNT = 10
export const MANYCHAT_BIRTH_DATE = 1420059600000 // 2015-01-01 00:00:00.0
export const ADD_LC_SEAT_OPTION = 'addLCSeat'

export const UNDELIVERED_ARTICLE_URL =
  'https://help.manychat.com/hc/en-us/articles/15580879039388-Why-WhatsApp-messages-are-sometimes-not-delivered'

export const NOTE_TYPES = {
  [ChannelType.FB]: ChatMessageType.USER_THREAD_NOTE,
  [ChannelType.INSTAGRAM]: ChatMessageType.USER_THREAD_NOTE_INSTAGRAM,
  [ChannelType.WHATSAPP]: ChatMessageType.USER_THREAD_NOTE_WHATSAPP,
  [ChannelType.TELEGRAM]: ChatMessageType.USER_THREAD_NOTE_TELEGRAM,
  [ChannelType.TIKTOK]: ChatMessageType.USER_THREAD_NOTE_TIKTOK,
  [ChannelType.SMS]: ChatMessageType.USER_THREAD_NOTE_SMS,
}

export const MESSAGE_TYPES = {
  [ChannelType.FB]: ChatMessageType.MSGOUT_LC,
  [ChannelType.INSTAGRAM]: ChatMessageType.MSGOUT_LC_INSTAGRAM,
  [ChannelType.WHATSAPP]: ChatMessageType.MSGOUT_LC_WHATSAPP,
  [ChannelType.TELEGRAM]: ChatMessageType.MSGOUT_LC_TELEGRAM,
  [ChannelType.TIKTOK]: ChatMessageType.MSGOUT_LC_TIKTOK,
  [ChannelType.SMS]: ChatMessageType.MSGOUT_LC_SMS,
}

export enum WhatsAppMessageFailedErrorCodes {
  MESSAGE_UNDELIVERABLE = 0,
  MESSAGE_IS_AN_EXPERIMENT = 1,
  META_CHOSE_NOT_TO_DELIVER = 2,
  SOMETHING_WENT_WRONG = 3,
}

const WhatsAppMessageUndeliveredUrl = {
  [WhatsAppMessageFailedErrorCodes.MESSAGE_UNDELIVERABLE]:
    UNDELIVERED_ARTICLE_URL + '#message-undeliverable',
  [WhatsAppMessageFailedErrorCodes.MESSAGE_IS_AN_EXPERIMENT]:
    UNDELIVERED_ARTICLE_URL + '#message-is-an-experiment',
  [WhatsAppMessageFailedErrorCodes.META_CHOSE_NOT_TO_DELIVER]:
    UNDELIVERED_ARTICLE_URL + '#meta-chose-not-to-deliver',
  [WhatsAppMessageFailedErrorCodes.SOMETHING_WENT_WRONG]: undefined,
}

export const whatsAppMessageUndeliveredContent: Record<
  WhatsAppMessageFailedErrorCodes,
  {
    text: MakeTranslateReturnValue
    url?: string
    getChatErrorText: (className: string) => MakeTranslateReturnValue
  }
> = {
  [WhatsAppMessageFailedErrorCodes.MESSAGE_UNDELIVERABLE]: {
    text: l.makeTranslate(
      `The recipient’s number might not be a WhatsApp number, or there could be another issue.`,
    ),
    url: WhatsAppMessageUndeliveredUrl[WhatsAppMessageFailedErrorCodes.MESSAGE_UNDELIVERABLE],
    getChatErrorText: (className: string) =>
      l.makeTranslate(
        `Message failed to send. <a class="{className}" href="{href}" target="_blank" rel="noreferrer">View possible reasons</a>.`,
        {
          href: WhatsAppMessageUndeliveredUrl[
            WhatsAppMessageFailedErrorCodes.MESSAGE_UNDELIVERABLE
          ],
          className,
        },
      ),
  },
  [WhatsAppMessageFailedErrorCodes.MESSAGE_IS_AN_EXPERIMENT]: {
    text: l.makeTranslate(`The recipient's number is part of an experiment.`),
    url: WhatsAppMessageUndeliveredUrl[WhatsAppMessageFailedErrorCodes.MESSAGE_IS_AN_EXPERIMENT],
    getChatErrorText: (className: string) =>
      l.makeTranslate(
        `Message to experimental number failed to send. <a class="{className}" href="{href}" target="_blank" rel="noreferrer">View possible reasons</a>.`,
        {
          href: WhatsAppMessageUndeliveredUrl[
            WhatsAppMessageFailedErrorCodes.MESSAGE_IS_AN_EXPERIMENT
          ],
          className,
        },
      ),
  },
  [WhatsAppMessageFailedErrorCodes.META_CHOSE_NOT_TO_DELIVER]: {
    text: l.makeTranslate('Meta chose not to deliver the message.'),
    url: WhatsAppMessageUndeliveredUrl[WhatsAppMessageFailedErrorCodes.META_CHOSE_NOT_TO_DELIVER],
    getChatErrorText: (className: string) =>
      l.makeTranslate(
        `Meta did not deliver message. <a class="{className}" href="{href}" target="_blank" rel="noreferrer">View possible reasons</a>.`,
        {
          href: WhatsAppMessageUndeliveredUrl[
            WhatsAppMessageFailedErrorCodes.META_CHOSE_NOT_TO_DELIVER
          ],
          className,
        },
      ),
  },
  [WhatsAppMessageFailedErrorCodes.SOMETHING_WENT_WRONG]: {
    text: l.makeTranslate('Something went wrong.'),
    getChatErrorText: () => l.makeTranslate(`Message failed to send.`),
  },
}

export const MAX_IMAGE_ATTACHMENT_SIZE_BYTES = 5000000 // 5 MB
export const MAX_WA_ATTACHMENT_SIZE_BYTES = 16000000 // 16 MB
export const MAX_WA_DOCUMENT_SIZE_BYTES = 50000000 // 50 MB
export const MAX_TG_ATTACHMENT_SIZE_BYTES = 20000000 // 20 MB
